module.exports = __webpack_public_path__ + "components/flag/static/square/ml-dd683fb03f48576bb6ee387f552a9290.svg";